/* jshint esversion: 6 */
/* jshint ignore:start */
import { useContext, useEffect, useRef, useState } from 'react';
import { RiSearchLine } from "react-icons/ri";
import { LuUser } from "react-icons/lu";
import { MyContext } from '../Context/MyProvider';
import Login from './Login';
import Signup from './Signup';
import { useLocation, useNavigate } from 'react-router-dom';
import { FaStar } from "react-icons/fa";
import axios from 'axios';
import { HiOutlineMenuAlt1 } from "react-icons/hi";
import SaidMenu from './Profile/SaidMenu';
import { useTranslation } from 'react-i18next';
import PhoneInput, { formatPhoneNumberIntl } from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { IoMdEye, IoMdEyeOff } from "react-icons/io";
import { showToast } from '../showTost';
import Logo from "../assets/Image/Logo.png";
import Loading from './Loading';
import secureLocalStorage from "react-secure-storage";
const Header = () => {

  const { ApiBaseUrl, ImgBaseUrl, isLoginShow, showBox, setIsLoginShow, setSelectProduct, setshowBox, setIsLogin, isSignUpShow, setIsSignUpShow, isLogin, setIsFooter, MenuRef, showMenu, setShowMenu, setActivePage, isShow, setIsShow } = useContext(MyContext);

  const { t, i18n } = useTranslation();

  const [userImg, setUserImg] = useState("");
  const [isShowImg, setIsShowImg] = useState(false);
  const [searchData, setSearchData] = useState([]);
  const [input, setInput] = useState();
  const [searchShow, setSearchShow] = useState(false);
  const [selectlag, setSelectLag] = useState('en');
  const [passType, setPassType] = useState("password");
  const [value, setValue] = useState();
  const [profilePic, setProfilePic] = useState();
  const [prodileData, setProfileData] = useState({ name: "", email: "", password: "" });
  const [apiloading, setApiLoading] = useState(false);
  const [searchstorelist, setSearchStoreList] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(1);
  const [lastScrollTop, setLastScrollTop] = useState(0);
  const [imgaddload, setImgAddLoad] = useState(false);

  const Language = [{ id: 'en', title: "English" }, { id: 'ar', title: "عربي" }, { id: 'hi', title: "Hindi" }, { id: 'sp', title: "Spanish" }, { id: 'fr', title: "French" }, { id: 'ge', title: "Germany" }, { id: 'in', title: "Indonesia" }, { id: 'sa', title: "South Africa" }, { id: 'tu', title: "Turkish" }, { id: 'po', title: "Portuguese" },];

  const Navigate = useNavigate();
  const location = useLocation();
  const isStorePage = location.pathname.includes('store-home');

  const InputRef = useRef();
  const FileRef = useRef();
  const NoMoreDataRef = useRef(true);

  const Currency = secureLocalStorage.getItem("currency");
  const LoginData = secureLocalStorage.getItem("Loginuser");

  if (LoginData) {
    var { country_code, name, email, phone } = JSON.parse(LoginData);
  }

  useEffect(() => {
    const Loginuser = secureLocalStorage.getItem("Loginuser");
    if (Loginuser) {
      const { image } = JSON.parse(Loginuser);
      setUserImg(image);
      setIsShowImg(true);
    } else {
      setUserImg("");
      setIsShowImg(false);
    }
  }, [isLogin]);

  useEffect(() => {
    if (!input) return;

    setSearchShow(true);
    setApiLoading(true);
    setPage(1);
    NoMoreDataRef.current = true;

    if (isStorePage) {
      HandleStoreSerch(input, 1);
    } else {
      setPage(1);
      HandleDoctorSearch(input, 1);
    }
  }, [input]);

  const HandleDoctorSearch = (inputText, currentPage) => {

    navigator.geolocation.getCurrentPosition(position => {

      const lat = String(position.coords.latitude);
      const long = String(position.coords.longitude);

      axios.post(`${ApiBaseUrl}/customer/search_doctor`, { text: inputText, lat: lat, lon: long, page: currentPage })
        .then((res) => {
          // console.log("search_doctor", res);
          if (res.data.ResponseCode === 200) {
            const newDoctors = res.data.doctor_list;
            if (newDoctors.length === 0) NoMoreDataRef.current = false;
            setSearchData(prev => currentPage === 1 ? newDoctors : [...prev, ...newDoctors]);
            setHasMore(true);
          }
          setApiLoading(false);
        })
        .catch((error) => {
          console.error(error);
        });
    });
  }

  const HandleStoreSerch = (input, page) => {
    const LocalData = sessionStorage.getItem("Docdetails");

    if (LocalData) {

      const { Docid } = JSON.parse(LocalData);
      const Userid = secureLocalStorage.getItem("Userid");

      axios.post(`${ApiBaseUrl}/customer/product_search`, { uid: Userid, search_field: input, doctor_id: Docid, page })
        .then((res) => {
          // console.log("product_search", res);
          const { ResponseCode, product_list } = res.data;
          if (ResponseCode === 200) {
            if (product_list.length === 0) NoMoreDataRef.current = false;
            setApiLoading(false);
            setSearchStoreList(product_list);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }

  const handleScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    if (scrollTop > lastScrollTop) {
      if (scrollTop + clientHeight >= scrollHeight - 10 && hasMore && NoMoreDataRef.current) {
        setHasMore(false);
        setPage(prev => prev + 1);
      }
    }
    setLastScrollTop(scrollTop);
  };

  useEffect(() => {
    if (page === 1 || !NoMoreDataRef) return;

    HandleDoctorSearch(input, page);

  }, [page])

  useEffect(() => {
    setProfileData({ name: name, email: email, password: "" });
    setValue(country_code + phone);
  }, [LoginData]);

  useEffect(() => {
    const Loginuser = secureLocalStorage.getItem("Loginuser");
    if (Loginuser) {
      const { image } = JSON.parse(Loginuser);
      if (image) {
        setProfilePic(ImgBaseUrl + image);
      }
    }
  }, []);

  const HandleNavigate = (index) => {
    if (index === 0) {
      setActivePage(0);
      Navigate("/");
      setIsFooter(false);
    } else {
      if (window.innerWidth > 1025) {
        setActivePage(1);
        Navigate("/dashbord/booking");
      } else {
        setActivePage(0);
        Navigate("/");
      }
    }
  };

  useEffect(() => {
    const lang = secureLocalStorage.getItem("I18");

    if (lang) {
      setSelectLag(lang);
    }
  }, []);

  const HandleNavigateDoc = (e, title, Id, departmentid) => {
    e.stopPropagation();

    Navigate("/doctor-profile");
    sessionStorage.setItem("Docprofile", JSON.stringify({ id: Id, department_id: departmentid, title: title, path: "/", pagename: "Home" }));

    setSearchShow(false);
    setInput("");
  };

  const changeLanguage = (lang) => {
    setSelectLag(lang);
    i18n.changeLanguage(lang);
    secureLocalStorage.setItem("I18", lang);
    setIsShow(false);
  };

  const HandleEditProfile = () => {
    const Userid = secureLocalStorage.getItem("Userid");

    if (!profilePic) {
      showToast({ title: t("Upload Profile Photo"), id: "error" });
      return;
    }

    if (!prodileData.name || !prodileData.email || !value) {
      showToast({ title: t("Enter details"), id: "error" });
      return;
    }

    setImgAddLoad(true);
    const formattedNumber = formatPhoneNumberIntl(value);
    const countryCode = formattedNumber.split(' ')[0];
    const numberWithoutCode = formattedNumber.replace(countryCode, '').trim();
    const cleanedNumber = numberWithoutCode.split(' ').join('');

    const formData = new FormData();

    formData.append("id", Userid);
    formData.append("image", profilePic);
    formData.append("name", prodileData.name);
    formData.append("email", prodileData.email);
    formData.append("password", prodileData.password ? prodileData.password : "");
    formData.append("ccode", countryCode);
    formData.append("phone", cleanedNumber);

    axios.post(`${ApiBaseUrl}/customer/edit_profile`, formData)
      .then((res) => {
        // console.log(res);
        const ToastId = res.data.ResponseCode === 200 ? "success" : "error";
        showToast({ title: res.data.message, id: ToastId });
        if (res.data.ResponseCode === 200) {
          secureLocalStorage.setItem("Loginuser", JSON.stringify(res.data.customer_detail));
          setshowBox("");
          setIsLogin("123");
        }
        setImgAddLoad(false);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const HandleShowMenu = () => {
    const Userid = secureLocalStorage.getItem("Userid");
    if (Userid) {
      MenuRef.current.classList.add('open');
      setShowMenu(true);
    } else {
      setIsLoginShow(true);
    }
  };

  const HandleSelectStore = (id) => {
    setSelectProduct(id);
    setSearchShow(false);
    setInput("");
  }


  return (
    <div className='left-0 right-0 sticky top-[10px] z-[999]'>

      <div className="header">

        <div className="logo-box">
          <button className='menuicon' onClick={HandleShowMenu} ><HiOutlineMenuAlt1 className='text-[25px]' /></button>
          <img onClick={() => HandleNavigate(0)} src={Logo} className='w-[60px] cursor-pointer object-cover' alt="Logo" />
        </div>

        <div className="info-box">
          <div className="search-box relative">
            <RiSearchLine className='icon' />
            <input type="text" value={input} onChange={(e) => setInput(e.target.value)} className='text-[16px]' placeholder={isStorePage ? t("Search Hevan Medical Store Product") : t("Search Doctor")} />

            {(input && searchShow) &&
              <div onScroll={handleScroll} className="w-[100%] max-h-[500px] absolute bg-[#F6F7F8] px-[10px] py-[5px] top-[65px] rounded-[10px] scroll-container z-[888]">
                {apiloading
                  ? <Loading CustomeStyle="w-full h-[480px] rounded-[10px] bg-white flex items-center justify-center" />
                  : <div className="">
                    {isStorePage
                      ? <div className="">
                        {searchstorelist.length >= 1
                          ? searchstorelist.map((item, index) => {
                            return <div key={index} onClick={() => HandleSelectStore(item.id)} className="bg-white py-[8px] px-[10px] rounded-[10px] overflow-hidden cursor-pointer mt-[5px]">
                              <div className="flex items-center gap-[10px]">
                                <img src={ImgBaseUrl + item.product_image} className='w-[70px] rounded-[10px] object-cover' alt="product_image" />
                                <div className="w-[80%]">
                                  <h1 className='font-[500] whitespace-nowrap overflow-hidden overflow-ellipsis'>{item.product_name}</h1>
                                  <div className="flex items-center gap-[10px]">
                                    <h1 className='font-bold'>{Currency}{item.price_detail[0].price}</h1>
                                    <span className='line-through'>{Currency}{item.price_detail[0].base_price}</span>
                                    <div className="bg-yellow-500 px-[8px] rounded-[50px]">
                                      <p className='font-[500] text-white text-[14px]'>{item.price_detail[0].discount}% {t("OFF")}</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          })
                          : <div className="bg-white h-[480px] rounded-[10px] flex items-center justify-center py-[20px]'">
                            <div className="text-center">
                              <h1 className='font-[500] text-[18px]'>{t("No product yet!")}</h1>
                              <p className='text-gray-600'>{t("Currently you don't have any")} <br /> {t("product in you area!.")}</p>
                            </div>
                          </div>}
                      </div>
                      : <div className="">
                        {searchData.length >= 1
                          ? searchData.map((item, index) => {
                            return <div onClick={(e) => HandleNavigateDoc(e, item.name, item.id, "0")} key={index} className="bg-white py-[8px] px-[10px] rounded-[10px] cursor-pointer mt-[5px]">
                              <div className="flex items-center gap-[10px]">
                                <img src={ImgBaseUrl + item.logo} className='max-w-[70px] min-w-[70px] h-[70px] rounded-[10px] object-cover border-[1px]' alt="" />
                                <div className="leading-[20px] w-[100%] overflow-hidden">
                                  <h1 className='font-[500] text-[17px] whitespace-nowrap overflow-hidden overflow-ellipsis'>{item.name}</h1>
                                  <p className='whitespace-nowrap overflow-hidden overflow-ellipsis'>{item.title}</p>
                                  <p className='whitespace-nowrap overflow-hidden overflow-ellipsis'>{item.subtitle}</p>
                                </div>
                              </div>
                              <div className="mt-[5px] flex items-center gap-[10px] justify-between">
                                {item.tot_favorite === 1 && <div className='flex items-center gap-[5px]'>
                                  <svg width="14" height="13" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M17.8299 7.46502C16.6569 13.515 8.99998 17 8.99998 17C8.99998 17 1.34292 13.515 0.168923 7.46502C-0.551077 3.75302 1.02197 0.018995 5.02097 -5.02745e-06C7.99997 -0.014005 8.99998 2.98797 8.99998 2.98797C8.99998 2.98797 10 -0.015005 12.978 -5.02745e-06C16.986 0.018995 18.5499 3.75402 17.8299 7.46502Z" fill="#0d4047" />
                                  </svg>
                                  <h1> {t("1 Love this")}</h1>
                                </div>}
                                <h1 className='flex items-center gap-[5px]'>
                                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12 22C15.375 22 21 15.7981 21 10.8889C21 5.97969 16.9706 2 12 2C7.02944 2 3 5.97969 3 10.8889C3 15.7981 8.625 22 12 22ZM12 14C13.6569 14 15 12.6569 15 11C15 9.34315 13.6569 8 12 8C10.3431 8 9 9.34315 9 11C9 12.6569 10.3431 14 12 14Z" fill="black" />
                                  </svg>
                                  {item.distance}
                                </h1>
                                <h1 className='flex items-center gap-[5px]'><FaStar className='text-orange-400' /> {item.avg_star} {t("Reviews")}</h1>
                              </div>
                            </div>
                          })
                          : <div className='bg-white h-[480px] rounded-[10px] flex items-center justify-center text-center py-[20px]'>
                            <div className="text-center">
                              <h1 className='font-[500] text-[18px]'>{t("No Doctor yet!")}</h1>
                              <p className='text-gray-600'>{t("Currently you don't have any")} <br /> {t("doctor in you area!.")}</p>
                            </div>
                          </div>}
                      </div>}
                  </div>}
              </div>
            }

          </div>

          <div className="call-box">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M16.5521 21.752C16.0931 21.752 15.6311 21.69 15.1751 21.565C9.01111 19.873 4.12909 14.995 2.43609 8.83402C2.05109 7.43302 2.26204 5.97301 3.03204 4.72501C3.80504 3.47101 5.0761 2.58701 6.5191 2.29801C7.4721 2.10701 8.4281 2.53301 8.9151 3.35501L10.4781 5.99399C11.2371 7.27599 10.86 8.92799 9.61896 9.75299L8.4881 10.505C9.5451 12.676 11.3229 14.458 13.4839 15.514L14.2462 14.377C15.0752 13.138 16.7281 12.767 18.0091 13.53L20.6522 15.106C21.4702 15.594 21.8941 16.548 21.7071 17.481C21.4191 18.924 20.5341 20.195 19.2811 20.968C18.4391 21.487 17.5021 21.752 16.5521 21.752ZM6.97809 3.75C6.92909 3.75 6.87911 3.75502 6.83111 3.76502C5.77711 3.97602 4.86512 4.611 4.31012 5.512C3.76112 6.402 3.61009 7.44101 3.88409 8.43601C5.43709 14.09 9.91608 18.566 15.5721 20.118C16.5671 20.391 17.605 20.239 18.493 19.691C19.393 19.136 20.0291 18.222 20.2361 17.186C20.2981 16.875 20.1571 16.556 19.8841 16.394L17.241 14.818C16.643 14.463 15.876 14.637 15.492 15.212L14.377 16.877C14.177 17.175 13.7911 17.289 13.4651 17.151C10.5021 15.913 8.09213 13.496 6.85113 10.522C6.71313 10.19 6.82999 9.80801 7.12799 9.60901L8.78912 8.504C9.36512 8.121 9.54007 7.35401 9.18707 6.75901L7.62408 4.12C7.48708 3.887 7.23909 3.75 6.97809 3.75ZM14.869 14.794H14.879H14.869ZM17.7501 10C17.7501 7.932 16.0671 6.25 14.0001 6.25C13.5861 6.25 13.2501 6.586 13.2501 7C13.2501 7.414 13.5861 7.75 14.0001 7.75C15.2401 7.75 16.2501 8.759 16.2501 10C16.2501 10.414 16.5861 10.75 17.0001 10.75C17.4141 10.75 17.7501 10.414 17.7501 10ZM20.7501 10C20.7501 6.278 17.7221 3.25 14.0001 3.25C13.5861 3.25 13.2501 3.586 13.2501 4C13.2501 4.414 13.5861 4.75 14.0001 4.75C16.8951 4.75 19.2501 7.105 19.2501 10C19.2501 10.414 19.5861 10.75 20.0001 10.75C20.4141 10.75 20.7501 10.414 20.7501 10Z" fill="#0d4047" />
            </svg>
            <div className="">
              <span className="">{t("Emergency Line")}</span>
              <h5 className="text[#0d4047] font-bold">+1 (234) 567 890 43</h5>
            </div>
          </div>
          <div className="email-box">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 20.75H6C3.582 20.75 2.25 19.418 2.25 17V8C2.25 5.582 3.582 4.25 6 4.25H18C20.418 4.25 21.75 5.582 21.75 8V17C21.75 19.418 20.418 20.75 18 20.75ZM6 5.75C4.423 5.75 3.75 6.423 3.75 8V17C3.75 18.577 4.423 19.25 6 19.25H18C19.577 19.25 20.25 18.577 20.25 17V8C20.25 6.423 19.577 5.75 18 5.75H6ZM13.0291 13.179L17.9409 9.60699C18.2759 9.36399 18.35 8.89401 18.106 8.55901C17.863 8.22501 17.3951 8.149 17.0581 8.394L12.146 11.966C12.058 12.03 11.941 12.03 11.853 11.966L6.94092 8.394C6.60292 8.149 6.13607 8.22601 5.89307 8.55901C5.64907 8.89401 5.72311 9.36299 6.05811 9.60699L10.97 13.18C11.278 13.404 11.639 13.515 11.999 13.515C12.359 13.515 12.7221 13.403 13.0291 13.179Z" fill="#0d4047" />
            </svg>

            <div className="">
              <span className="">{t("Support Email")}</span>
              <h5 className="text[#0d4047] font-bold">support@cscodetech.com</h5>
            </div>
          </div>
          <div className="">
            {isShowImg
              ? <button onClick={() => HandleNavigate(1)} className='w-[50px] h-[50px] rounded-[100%] overflow-hidden' >
                {userImg
                  ? <img src={ImgBaseUrl + userImg} className='w-[100%] h-[100%]' alt="" />
                  : <div className="bg-[#F3F4F6] w-[100%] h-[100%] flex items-center justify-center font-[500] text-[20px]">
                    <span className='-mt-[6px]'>{name?.split("")[0]}</span>
                  </div>}
              </button>
              : <button onClick={() => setIsLoginShow(true)} className="login-btn">
                <LuUser />
                <h4 className='font-[500]'>{t("Login")}</h4>
              </button>}
          </div>
        </div>

      </div>

      <div ref={MenuRef} className="menu scroll-container">
        <SaidMenu index={1} />
      </div>

      {isLoginShow && <div onClick={() => setIsLoginShow(false)} className="flex bg-[#00000069] h-full justify-center w-full fixed items-center left-0 top-0 z-[999]">
        <div onClick={(e) => e.stopPropagation()} className="model">
          <Login />
        </div>
      </div>}

      {isSignUpShow && <div onClick={() => setIsSignUpShow(false)} className="flex bg-[#00000069] h-full justify-center w-full fixed items-center left-0 top-0 z-[999]">
        <div onClick={(e) => e.stopPropagation()} className="model">
          <Signup />
        </div>
      </div>}

      {showMenu && <div onClick={() => { MenuRef.current.classList.remove('open'); setShowMenu(false) }} className="overlay bg-[#00000080]"></div>}

      {searchShow && <div onClick={() => { setSearchShow(false); setInput("") }} className="overlay"></div>}

      {isShow && <div onClick={() => setIsShow("")} className="flex bg-[#00000069] h-full justify-center w-full fixed items-center left-0 top-0 z-[999]">
        <div onClick={(e) => e.stopPropagation()} className="bottme-box ">
          {Language.map((item, index) => {
            return <div key={index} onClick={() => changeLanguage(item.id, index)} className=" cursor-pointer border-[1px] border-[#8080803b] py-[8px] px-[10px] rounded-[10px] mt-[10px]">
              <div className="flex items-center gap-[10px] justify-between">
                <h1 className='font-[500] text-[15px]'>{item.title}</h1>
                <div className="w-[30px] check-box">
                  <input id="radio1" className="peer hidden" type="radio" name="group1" />
                  <div className={`w-5 h-5 rounded-full flex items-center justify-center ${selectlag === item.id ? "box-activeborder" : "box-border"}`}>
                    <span className={`w-[10px] h-[10px] rounded-full duration-[0.3s] ${selectlag === item.id && "box-activebg"}`}></span>
                  </div>
                </div>
              </div>
            </div>
          })}
        </div>
      </div>}

      {showBox && <div onClick={() => setshowBox("")} className="flex bg-[#00000069] h-full justify-center w-full fixed items-end left-0 top-0 z-[999]">
        <div style={{ borderRadius: "10px 10px 0 0" }} onClick={(e) => e.stopPropagation()} className="bottme-box">
          <h1 className='font-[500] text-[17px]'>{t("Edit Profile")}</h1>

          <div className="px-[20px] mt-[10px]">
            <button onClick={() => FileRef.current.click()} className="border-[1px] w-[100%] border-dashed border-[#0d4047] h-[150px] rounded-[15px] cursor-pointer flex items-center justify-center overflow-hidden ">
              {profilePic
                ? <img src={profilePic} className='w-[40%] h-[90%] object-cover rounded-[10px]' alt="" />
                : <h1 className='text-[#0d4047] text-[25px]'>+</h1>
              }
            </button>

            <input
              ref={FileRef}
              onChange={(e) => setProfilePic(URL.createObjectURL(e.target.files[0]))}
              type="file"
              accept="image/*"
              className='hidden'
            />

            <input value={prodileData.name} onChange={(e) => setProfileData({ ...prodileData, name: e.target.value })} className='w-[100%] border-[2px] border-[#8080803b] outline-none mt-[10px] rounded-[10px] px-[10px] py-[8px] focus-within:border-[#0d4047]' type="text" placeholder={name} />
            <input value={prodileData.email} onChange={(e) => setProfileData({ ...prodileData, email: e.target.value })} className='w-[100%] border-[2px] border-[#8080803b] outline-none mt-[10px] rounded-[10px] px-[10px] py-[8px] focus-within:border-[#0d4047]' type="text" placeholder={email} />
            <div className="relative border-[2px] border-[#8080803b] outline-none mt-[10px] rounded-[10px] px-[10px] py-[8px] focus-within:border-[#0d4047]">
              <PhoneInput
                className="w-[100%]"
                ref={InputRef}
                international
                defaultCountry="IN"
                value={value}
                onChange={setValue}
                name="phone"
                style={{ outline: "none" }}
              />
              {!value && <h1 onClick={() => InputRef.current.focus()} className='absolute top-[8px] left-[60px] text-gray-500'>{phone}</h1>}
            </div>
            <div className="relative">
              <input value={prodileData.password} onChange={(e) => setProfileData({ ...prodileData, password: e.target.value })} className='w-[100%] border-[2px] border-[#8080803b] outline-none mt-[10px] rounded-[10px] px-[10px] py-[8px] focus-within:border-[#0d4047]' type={passType} placeholder='Enter Password (Optional)' />
              <div className="absolute top-[23px] right-[20px]">
                {passType === "password" ? <IoMdEyeOff onClick={() => setPassType("text")} className='text-gray-500 text-[20px] cursor-pointer' /> : <IoMdEye onClick={() => setPassType("password")} className='text-gray-500 text-[20px] cursor-pointer' />}
              </div>
            </div>
            <button onClick={HandleEditProfile} className="payment-btn mt-[15px]">
              {imgaddload
                ? <div className="loader mx-auto"></div>
                : <span>{t("Update")}</span>}
            </button>
          </div>
        </div>
      </div>}

    </div>
  )
}

export default Header;
/* jshint ignore:end */
